import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": "",
      "min-width": "300",
      "max-width": "300",
      "nudge-left": "12",
      "offset-x": "",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [!_vm.isMobile ? _c('core-button', _vm._g({
          staticClass: "mr-2",
          attrs: {
            "data-cy": "btn_toolbar-menu",
            "title": _vm.$i18n_t('Common.customizeInterface'),
            "color": _vm.color,
            "solid-icon": "",
            "prepend-icon": "fa-cog"
          }
        }, on)) : _c(VBtn, _vm._g({
          attrs: {
            "data-cy": "btn_toolbar-menu",
            "title": _vm.$i18n_t('Common.customizeInterface'),
            "text": "",
            "small": ""
          }
        }, on), [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.customizeInterface')) + "\n    ")])];
      }
    }])
  }, [_c(VCard, [_c(VContainer, {
    staticClass: "pa-6",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.colorScheme')))]), _c(VRow, {
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.colors, function (c) {
    return _c(VAvatar, {
      key: `color-${c}`,
      staticClass: "mx-1",
      attrs: {
        "size": 23
      },
      on: {
        "click": function ($event) {
          return _vm.updateUserDefaults('color', c);
        }
      }
    }, [_c('div', {
      class: ['filterColorPreview-wrapper', `filterColorPreview-${c}`, _vm.localUser.properties.userDefaults.color === c ? 'active' : '']
    })]);
  }), _vm.hasCustomColor ? _c(VAvatar, {
    class: `${_vm.color.startsWith('customerColor') ? 'color-active' : ''} filterColorPreview-customerColor${_vm.UiTheme ? 'Dark' : 'Light'}`,
    attrs: {
      "size": "23"
    }
  }) : _vm._e()], 2), _c(VDivider, {
    staticClass: "mt-4"
  })], 1), _c(VCol, {
    attrs: {
      "cols": "4"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.language')))]), _c(VRow, {
    staticClass: "mt-2",
    attrs: {
      "justify": "center"
    }
  }, _vm._l(['de', 'gb'], function (code) {
    return _c('div', {
      key: `lang-${code}`,
      staticClass: "mx-1"
    }, [_c(VAvatar, {
      attrs: {
        "size": 25,
        "data-cy": `lang-${code === 'gb' ? 'en' : code}`
      },
      on: {
        "click": function ($event) {
          return _vm.updateUserDefaults('language', code === 'gb' ? 'en' : code);
        }
      }
    }, [_c('div', {
      class: ['flag-icon-custom', `flag-icon-${code}`, 'flag-wrapper-custom', _vm.localUser.properties.userDefaults.language === (code === 'gb' ? 'en' : code) ? 'active' : '']
    })])], 1);
  }), 0)], 1), _c(VCol, {
    attrs: {
      "cols": "8"
    }
  }, [_c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.mapLayout')))]), _c(VSelect, {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "items": _vm.mapStyles,
      "hide-details": "",
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "label": _vm.$i18n_t('Common.select'),
      "solo": ""
    },
    model: {
      value: _vm.localUser.properties.userDefaults.mapLayout,
      callback: function ($$v) {
        _vm.$set(_vm.localUser.properties.userDefaults, "mapLayout", $$v);
      },
      expression: "localUser.properties.userDefaults.mapLayout"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDivider, {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "text-center text-body-2 text-uppercase sidebar-filter"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.uiSettings')))]), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_mode",
      "label": _vm.$store.state.app.UiTheme ? _vm.$i18n_t('Common.uiDark') : _vm.$i18n_t('Common.uiLight'),
      "color": _vm.color
    },
    model: {
      value: _vm.localUser.properties.userDefaults.uiTheme,
      callback: function ($$v) {
        _vm.$set(_vm.localUser.properties.userDefaults, "uiTheme", $$v);
      },
      expression: "localUser.properties.userDefaults.uiTheme"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_drawer",
      "label": _vm.$store.state.app.drawer ? _vm.$i18n_t('Common.uiMenuOn') : _vm.$i18n_t('Common.uiMenuOff'),
      "color": _vm.color
    },
    model: {
      value: _vm.localUser.properties.userDefaults.drawer,
      callback: function ($$v) {
        _vm.$set(_vm.localUser.properties.userDefaults, "drawer", $$v);
      },
      expression: "localUser.properties.userDefaults.drawer"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_mini_variant",
      "label": _vm.$i18n_t('Common.toggleMiniVariant'),
      "color": _vm.color
    },
    model: {
      value: _vm.localUser.properties.userDefaults.miniVariant,
      callback: function ($$v) {
        _vm.$set(_vm.localUser.properties.userDefaults, "miniVariant", $$v);
      },
      expression: "localUser.properties.userDefaults.miniVariant"
    }
  }), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "data-cy": "btn_toggle_map3d",
      "label": _vm.$i18n_t('Common.ui3DMap'),
      "color": _vm.color
    },
    model: {
      value: _vm.localUser.properties.userDefaults.map3DBuild,
      callback: function ($$v) {
        _vm.$set(_vm.localUser.properties.userDefaults, "map3DBuild", $$v);
      },
      expression: "localUser.properties.userDefaults.map3DBuild"
    }
  }), _c(VDivider, {
    staticClass: "mt-2"
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c(VBtn, {
    attrs: {
      "data-cy": "btn_reset",
      "small": ""
    },
    on: {
      "click": _vm.resetDefaults
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.reset')))])], 1)])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };